import {decryptVariables} from './crypto';
import {EnvVariables} from './type';

const IS_CLIENT = typeof window !== 'undefined';
let env: EnvVariables | undefined;

export function getEnv(key: keyof EnvVariables): string | undefined {
  if (IS_CLIENT) {
    const encryptedVariables = window.encryptedVariables;

    // 파일변수 env가 있는경우 해당 변수를 사용한다.
    if (env) {
      // 파일변수가 env가 있으면서 window 객체에 암호화된 환경변수가 있다면 제거한다.
      if (encryptedVariables) {
        delete window.encryptedVariables;
      }
      return env[key];
    }
    if (!encryptedVariables) {
      return;
    }
    const decryptedVariables = decryptVariables(encryptedVariables) || {};
    // 파일변수에 복호화된 환경변수를 할당한다.
    env = decryptedVariables;
    return decryptedVariables?.[key];
  } else {
    return process.env[key];
  }
}
